import { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetPaginatedDoctypeDataQuery,
  useGetDoctypeCountQuery
} from "../../../../../store/api/warehousemaster";

import ActionButtonDropdown from "../../../../../Components/ActionButtonDropdown";
// import SearchFilters from "../../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../../Core/Layout/ListLayout";
import Table from "../../../../../Core/Table/Table";
import Tabs from "../../../../../Components/Tabs";
// import ConfigureColumns from "./ConfigureColumns";
import ExportCSV from '../../../../../Core/Export/ExportCSV'
import ConfigureColumnsNew from "../../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ListFilters from "../../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from '../../../../../utils/useScreenHeight'
const Lpntable = () => {
  const navigate = useNavigate();
	const { screenHeight, screenScaling,pageSize } = useScreenHeight();
  const [rawFilters, setRawFilters] = useState({});
  const [formattedFilters, setFormattedFilters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [filters, setFilters] = useState('');
  const [showExportPopup, setShowExportPopup] = useState(false);
  const doctype = "Warehouse";
	const [deleteDoc] = useDeleteDocMutation();
	const [delPopupVisible, setDelPopupVisible] = useState(false);
	const [delSelectedId, setDelSelectedId] = useState(null);
	const [delmessage, setDelmessage] = useState();
	const [alreadySubmitData, setAlreadySubmitData] = useState(false);
	const [delDone, setDelDone] = useState(false);
  const { data: countData, isLoading: isCountLoading } = useGetDoctypeCountQuery("Warehouse");
  const [showFilters, setShowFilters] = useState(false)

  const { data: paginatedData, isLoading: isDataLoading,refetch:refetchWareHouseData } = useGetPaginatedDoctypeDataQuery({
    doctype: "Warehouse",
    start: pageSize * (currentPage - 1),
    page_length: pageSize,
    filters: formattedFilters,
    fields: ["name", "warehouse_type", "company", "creation", "disabled"]
  });

  const warehouseData = paginatedData || { full_data: [], total_no_of_records: 0 };

  const filtersConfig = [
    { name: "siNo", label: "SI.No", width: "3.6%",type:'number' },
    { name: "name", label: "Warehouse Name", width: "15%",type:'text'  },
    { name: "warehouse_type", label: "Type", width: "15%",type:'text'  },
    { name: "company", label: "Company", width: "15%" ,type:'text' },
    { name: "creation", label: "Created On", type: "date", width: "15%" },
    {
      name: "disabled",
      label: "Status",
      width: "15%",
      type: "select",
      options: [
        { value: "0", label: "Active" },
        { value: "1", label: "Disabled" }
      ]
    }
  ];

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);

    const { siNo, ...rest } = newFilters;

    const transformed = Object.entries(rest)
      .filter(([_, value]) => value !== "" && value !== undefined && value !== null)
      .map(([key, value]) => ["Warehouse", key, "like", `%${value}%`]);

    setFormattedFilters(transformed);
  };
  const handleView = (id) => {
    navigate("/master/bin-view", { state: { name: id } });
  };

  const handleEdit = (id) => {
    navigate("/master/bin-edit", { state: { name: id } });
  };

  const handleDelete = (id) => {
		setDelSelectedId(id);
		setDelPopupVisible(true);
		setAlreadySubmitData(false);
		setDelmessage(`Are you sure you want to Delete this ${doctype}?`);
	};

	const delHandleCancel = () => {
		setDelPopupVisible(false);
		setDelSelectedId(null);
	};

	const delHandleConfirm = async () => {
		try {
			await deleteDoc({
				doctype: doctype,
				name: delSelectedId,
			}).unwrap();
			setDelmessage(`${doctype} ${delSelectedId} deleted successfully!`);
			setDelDone(true);
			setTimeout(() => {
				setDelPopupVisible(false);
				setDelSelectedId(null);
				setDelDone(false);
        refetchWareHouseData();
			}, 1000);
		} catch (err) {
			console.error("Deletion Failed:", err);

			let errorMessage = "Failed to delete the Purchase Receipt!";

			//If the server is sending the error message , we will extract it.
			if (err?.data?._server_messages) {
				try {
					const messageArr = JSON.parse(err.data._server_messages);
					if (messageArr && messageArr.length > 0) {
						//parse inner json object
						const messageObj = JSON.parse(messageArr[0]);
						if (messageObj?.message) {
							//extract the exact message we want
							const fullMessage = messageObj.message;
							errorMessage = fullMessage.split("You must")[0].trim();
							//remove html in the message
							errorMessage = errorMessage.replace(/<[^>]+>/g, "");
						}
					}
				} catch (parseError) {
					console.error("Error parsing server messages:", parseError);
				}
			}
			setDelPopupVisible(true);
			setDelmessage(errorMessage);
			setAlreadySubmitData(true);
		} finally {
			// setTimeout(() => {
			//     setDelPopupVisible(false);
			//     setDelSelectedId(null);
			// }, 2000);
		}
	};

  const [columnsConfig, setColumnsConfig] = useState(() => [
    {
      header: "SI No.",
      name: "SI No.",
      accessor: "siNo",
      width: "5.2%",
      sortable: false,
      visible: true,
      cellRenderer: (row) => row.siNo,
    },
    {
      header: "Warehouse Name",
      name: "Warehouse Name",
      accessor: "name",
      width: "15%",
      sortable: false,
      visible: true,
    },
    {
      header: "Type",
      name: "Type",
      accessor: "warehouse_type",
      width: "15%",
      sortable: false,
      visible: true,
    },
    {
      header: "Company",
      name: "Company",
      accessor: "company",
      width: "15%",
      sortable: false,
      visible: true,
    },
    {
      header: "Created On",
      name: "Created On",
      accessor: "creation",
      width: "15%",
      sortable: true,
      visible: true,
      cellRenderer: (row) => new Date(row.creation).toLocaleDateString()
    },
    {
      header: "Status",
      name: "Status",
      accessor: "disabled",
      width: "15%",
      sortable: false,
      visible: true,
      cellRenderer: (row) => (
        <span style={{ color: row.disabled ? "#EF4444" : "#16A34A" }}>
          {row.disabled ? "Disabled" : "Active"}
        </span>
      )
    },
    {
      header: "Action",
      name: "Action",
      accessor: "action",
      width: "10%",
      sortable: false,
      visible: true,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.name}
          onView={() => handleView(row.name)}
          onEdit={() => handleEdit(row.name)}
          onDelete={() => handleDelete(row.name)}
        />
      )
    }
  ]);

  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns)
  }
  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);

  useEffect(() => {
		if (pageSize > 0) refetchWareHouseData();
		// console.log("Fetch",pageSize)
	}, [
		pageSize,
		currentPage,
		refetchWareHouseData,
		screenHeight,
		screenScaling,
	]);
  const actionButtons = [
    {
      className: "createbtnsfilter border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtnshowmore border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtnexport border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/create-bin",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add New Bin"
    }
  ];
  const accessors = columnsConfig
        .filter(column => column.accessor !== "siNo" && column.accessor !=="action")
        .map(column => column.accessor);
  return (
    <div className="container-fluid d-flex flex-column" style={{ flexGrow: "1" }}>
      <Tabs />
      <ListLayout
        breadcrumbItems={[
          { label: "Bin" },
          { label: "Bin List", style: { color: "#4b002b" } }
        ]}
        actionButtons={actionButtons}
      >
        {
          showFilters && <ListFilters
            filtersConfig={filtersConfig}
            onFilterChange={handleFilterChange}
            currentFilters={filters}
            setShowFilters={setShowFilters}
          />
        }

        {showColumnConfig &&
          <ConfigureColumnsNew
            show={showColumnConfig}
            onClose={() => setShowColumnConfig(false)}
            onSave={handleSaveColumns}
            docType="Warehouse"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map(col => ({
              fieldname: col.accessor,
              label: col.name
            }))}
            disabledFields={["siNo", "disabled", "action", "warehouse_type", "name"]}
          />}

        <Table
          columns={visibleColumns}
          data={
            filters.siNo
              ? warehouseData.full_data
                .map((row, index) => ({
                  ...row,
                  siNo: index + 1 + pageSize * (currentPage - 1),
                }))
                .filter((row) => row.siNo === Number(filters.siNo))
              : warehouseData.full_data.map((row, index) => ({
                ...row,
                siNo: index + 1 + pageSize * (currentPage - 1),
              }))
          }
          loading={isDataLoading || isCountLoading}
        />

        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          totalRecords={countData?.message || 0}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />
        {delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
				)}
        {showExportPopup && (
          <ExportCSV
            doctype="Warehouse"
            fieldsData={accessors}
            onClose={() => setShowExportPopup(false)}
          />
        )}
      </ListLayout>

    </div>
  );
};

export default Lpntable;
